import { selectCurrency } from '@/redux/config/configSlice';
import { DiscountType } from '@/redux/data/dataTypes';
import { useAppSelector } from '@/redux/hooks';
import { DollarOutlined, PercentageOutlined } from '@ant-design/icons';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface DiscountItemProps {
  discount: DiscountType;
  onItemPress?: (discount: DiscountType) => void;
}

const DiscountItem: FC<DiscountItemProps> = ({ discount, onItemPress }) => {
  const { i18n } = useTranslation();
  const isPercentage = discount.type === 'PERCENT';
  const currency = useAppSelector(selectCurrency);
  const lang = i18n.language;
  const isArabic = lang === 'ar';

  return (
    <div
      onClick={() => onItemPress?.(discount)}
      className="group flex flex-row items-center gap-3 cursor-pointer transition-all duration-300 bg-white dark:bg-gray-600 hover:bg-gray-50 dark:hover:bg-gray-500 rounded-lg p-3 m-1 shadow-sm hover:shadow-md"
    >
      <div className="w-11 h-11 rounded-lg flex items-center justify-center flex-shrink-0 bg-[#e6f7ff] dark:bg-gray-500 text-frenchBlue dark:text-white transition-all duration-300 group-hover:scale-105">
        {isPercentage ? (
          <PercentageOutlined className="text-xl" />
        ) : (
          <DollarOutlined className="text-xl" />
        )}
      </div>

      <div className="flex flex-row min-h-[60px] py-1 items-center justify-between flex-1">
        <div className="flex-1 space-y-1">
          <div className="text-[15px] font-semibold text-gray-900 dark:text-white group-hover:text-frenchBlue dark:group-hover:text-white transition-colors duration-300">
            {isArabic && discount.nameAr ? discount.nameAr : discount.name}
          </div>
          <div className="text-[12px] text-gray-500 dark:text-gray-300">
            {isPercentage ? 'Percentage discount' : 'Fixed amount discount'}
          </div>
        </div>

        <div className="min-w-[65px] text-right ml-3 flex-shrink-0">
          <div className="bg-gray-100 dark:bg-gray-500 rounded-lg px-3 py-1.5">
            <span className="text-[14px] font-bold text-frenchBlue dark:text-white whitespace-nowrap">
              {discount.value ?? '-'} {isPercentage ? '%' : currency}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DiscountItem;
